import axios from 'axios';
import { config } from 'config/config';
import { addAxiosInterceptors } from 'supertokens-auth-react/recipe/session';

const axiosInstance = axios.create({ baseURL: config.apiUrl, withCredentials: true });
addAxiosInterceptors(axiosInstance);

export default axiosInstance;
